import { render } from "./IndustryTrend.vue?vue&type=template&id=858d7668&scoped=true"
import script from "./IndustryTrend.vue?vue&type=script&lang=js"
export * from "./IndustryTrend.vue?vue&type=script&lang=js"

import "./IndustryTrend.vue?vue&type=style&index=0&id=858d7668&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-858d7668"]])

export default __exports__